<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="pl_15 pr_15">
          <div class="d_flex_btwn title st_edit_title">
              <h2>{{ title }}</h2>
              <router-link :to="{ name: 'lecture_video_list'}" class="btn btn_info">{{ $t('common.back') }}</router-link>
          </div>
        </div>
        <div  class="pl_15 pr_15">
          <div class="card no_border student_profile_edit">
              <div :class="['card-body']">
                <div class="row">
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('category_id')}]">
                      <label>{{ $t('category') }}</label>
                      <select v-model="form.category_id" class="form_global">
                        <option value="">{{ $t('select_category') }}</option>
                        <option :value="category.id" v-for="category in categories" :key="'category '+category.id">{{ category.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('category_id')" />
                    </div>
                  </div>

                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('subject_id')}]">
                      <label>{{ $t('common.subject') }}</label>
                      <select v-model="form.subject_id" class="form_global">
                        <option value="">{{ $t('common.select_subject') }}</option>
                        <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('subject_id')" />
                    </div>
                  </div>

                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('area_id')}]">
                      <label>{{ $t('common.area') }}</label>
                      <select v-model="form.area_id" class="form_global">
                        <option value="">{{ $t('common.select_area') }}</option>
                        <option :value="area.id" v-for="area in areas" :key="'area_'+area.id">{{ area.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('area_id')" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('portion_id')}]">
                      <label>{{ $t('common.portion') }}</label>
                      <select v-model="form.portion_id" class="form_global">
                        <option value="">{{ $t('common.select_portion') }}</option>
                        <option :value="portion.id" v-for="portion in portions" :key="'portion '+portion.id">{{ portion.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('portion_id')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('grade_id')}]">
                      <label>{{ $t('common.grade') }}</label>
                      <select v-model="form.grade_id" class="form_global">
                        <option value="">{{ $t('common.select_grade') }}</option>
                        <option :value="grade.id" v-for="grade in grades" :key="'grade '+grade.id">{{ grade.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('grade_id')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                      <label>{{ $t('common.semester') }}</label>
                      <select v-model="form.semester_id" class="form_global">
                        <option value="">{{ $t('common.select_semester') }}</option>
                        <option :value="semester.id" v-for="semester in semesters" :key="'semester '+semester.id">{{ semester.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('semester_id')" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('parking_id')}]">
                      <label>{{ $t('common.parking') }}</label>
                      <select v-model="form.parking_id" class="form_global">
                        <option value="">{{ $t('common.select_parking') }}</option>
                        <option :value="parking.id" v-for="parking in parkings" :key="'parking '+parking.id">{{ parking.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('parking_id')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('chapter_id')}]">
                      <label>{{ $t('common.chapter') }}</label>
                      <select v-model="form.chapter_id" class="form_global">
                        <option value="">{{ $t('common.select_chapter') }}</option>
                        <option :value="chapter.id" v-for="chapter in chapters" :key="'parking '+chapter.id">{{ chapter.name }}</option>
                      </select>
                      <v-errors :errors="errorFor('chapter_id')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('page_number')}]">
                      <label>{{ $t('sidebar.lectureCommon.page_number') }}</label>
                      <input type="number" class="form_global" v-model="form.page_number" min="0">
                      <v-errors :errors="errorFor('page_number')" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('video_name')}]">
                      <label>{{ $t('common.name') }}</label>
                      <input type="text" class="form_global" v-model="form.video_name">
                      <v-errors :errors="errorFor('video_name')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('learning_goal')}]">
                      <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                      <input type="text" class="form_global" v-model="form.learning_goal">
                      <v-errors :errors="errorFor('learning_goal')" />
                    </div>
                  </div>
                  <div class="col_4">
                    <div :class="['form-group', {'has_error': errorFor('status')}]">
                      <label>{{ $t('common.status') }}</label>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input type="radio" id="active" value="1" v-model="form.status">
                          <label for="active">{{ $t('common.active') }}</label>
                        </div>
                        <div class="form_radio">
                          <input type="radio" id="inactive" value="0" v-model="form.status">
                          <label for="inactive">{{ $t('common.inactive') }}</label>
                        </div>
                      </div>
                      <v-errors :errors="errorFor('status')" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col_12">
                    <div :class="['form-group', {'has_error': errorFor('lecture_information')}]">
                      <label>{{ $t('sidebar.lectureCommon.lecture_information') }}</label>
                      <text-editor v-model:text="form['lecture_information']" :id="'lecture_video'"></text-editor>
                      <v-errors :errors="errorFor('lecture_information')" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col_12">
                    <div :class="['form-group', {'has_error': errorFor('video_upload')}]">
                      <label>{{ $t('sidebar.lectureCommon.video_upload') }}</label>
                      <div class="progress_wrap" v-if="showProgressbar">
                        <div class="meter">
                            <span :style="{ 'width': + uploadProgress + '%' } "><span class="progress"></span></span>
                            <div class="percent">{{ uploadProgress }}%</div>
                        </div>
                      </div>
                      <vue-dropzone class="create_images_drag" id="upload_dropzone" ref="upload_dropzone" :options="dropzoneOptions"
                        @vdropzone-total-upload-progress="dropzoneUploadProgress"
                        @vdropzone-file-added="dropzoneFileAdded"
                        @vdropzone-success="dropzoneSuccess"
                        @vdropzone-complete="dropzoneComplete"
                        :useCustomSlot="true">
                      </vue-dropzone>
                      <p class="showErrorMessage" style="color:red" v-if="showUploadError">{{ showUploadErrorMsg }}</p>
                      <v-errors :errors="errorFor('video_upload')" />
                    </div>
                  </div>
                </div>

                <div class="d_flex_end">
                  <button class="btn btn_md btn_success" :disabled="disabled" @click.prevent="submit()">{{ $t('common.save') }}</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone-vue3'
import TextEditor from "@/components/shared/TextEditor";
export default {
  components: { vueDropzone, TextEditor },
  data() {
    return {
      title: this.$t('createLectureVideo'),
      cancelRouteName: 'lecture_video_list',
      categories: [],
      subjects: [],
      areas: [],
      portions: [],
      grades: [],
      semesters: [],
      parkings: [],
      chapters: [],
      form: {
        category_id: '',
        subject_id: '',
        area_id: '',
        portion_id: '',
        grade_id: '',
        semester_id: '',
        parking_id: '',
        chapter_id: '',
        page_number: '',
        status: 1,
        video_name: '',
        learning_goal: '',
        lecture_information: '',
        files: '',
        originalFiles: '',
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
        addRemoveLinks: false,
        uploadMultiple: false,
        disablePreviews: false,
        createImageThumbnails: true,
        allowMultiple: false,
        maxFiles: 1,
        previewTemplate: '<div></div>',
        init: function() {
            this.on("error", function(file){
                this.showUploadError = true
                this.showUploadErrorMsg = '파일 업로드 실패 : ' + file.xhr.statusText;
            });
        },
        maxFilesize: 5120,
        thumbnailHeight: 120,
        timeout: 9999990000,
        acceptedFiles: "video/mp4,video/x-m4v,video/*",
        headers: {
          "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
        }
      },
      showUploadError : false,
      showUploadErrorMsg : '',
      showProgressbar: false,
      tempFile: null,
      uploadProgress: 0,
      disabled: true
    }
  },
  created() {
    this.axios.get('/lecture-categories').then((response) => this.categories = response.data.data);
    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
    this.axios.get('/areas').then((response) => this.areas = response.data.data);
    this.axios.get('/portions').then((response) => this.portions = response.data.data);
    this.axios.get('/grades').then((response) => this.grades = response.data.data);
    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
    this.axios.get('/parkings').then((response) => this.parkings = response.data.data);
    this.axios.get('/chapters').then((response) => this.chapters = response.data.data);

    if (this.$route.name === 'lecture_video_edit') {
      this.axios.get('/lectures/'+this.$route.params.id)
        .then((response) => {
          let videoData = response.data.data;
          this.form.category_id = videoData.category ? videoData.category.id : ''
          this.form.subject_id = videoData.subject ? videoData.subject.id : ''
          this.form.area_id = videoData.area ? videoData.area.id : ''
          this.form.portion_id = videoData.portion ? videoData.portion.id : ''
          this.form.grade_id = videoData.grade ? videoData.grade.id : ''
          this.form.semester_id = videoData.semester ? videoData.semester.id : ''
          this.form.parking_id = videoData.parking ? videoData.parking.id : ''
          this.form.chapter_id = videoData.chapter ? videoData.chapter.id : ''
          this.form.page_number = videoData.page_number
          this.form.status = videoData.status
          this.form.video_name = videoData.video_name
          this.form.learning_goal = videoData.learning_goal
          this.form.lecture_information = videoData.lecture_information
          this.form.files = videoData.original_filename
          this.form.originalFiles = videoData.original_filename
        })
      this.title = this.$t('editLectureVideo');
      this.disabled = false
    }
  },
  methods: {
    dropzoneFileAdded(){
      this.showUploadError = false
      this.showUploadErrorMsg = '';
    },
    dropzoneUploadProgress(totaluploadprogress){
        this.showProgressbar = true;
        this.uploadProgress = parseInt(totaluploadprogress)
    },
    dropzoneSuccess(file, response){
      this.form.files = response.original_filename;
      this.form.originalFiles = file.name;
    },
    dropzoneComplete(response){
        if(response.status == 'success' && this.uploadProgress == 100){
          this.disabled = false
        }
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'lecture_video_edit') {
        this.loading = true;
        this.errors = null;

        let formData = new FormData();

        Object.keys(this.form).forEach(key => {
          formData.append(key, this.form[key] ? this.form[key] : '');
        })

        formData.append('_method','PATCH')

        this.axios.post('/lectures/'+this.$route.params.id, formData)
          .then(() => {
            this.$router.push({name: 'lecture_video_list'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let formData = new FormData()

        Object.keys(this.form).forEach(key => {
            formData.append(key, this.form[key] ? this.form[key] : '');
        })

        this.axios.post('/lectures', formData)
          .then(() => {
            this.$router.push({name: 'lecture_video_list'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
